import React, { useState } from 'react';
import {
    Container,
    Typography,
    Paper,
    Box,
    ToggleButtonGroup,
    ToggleButton,
    Link,
} from '@mui/material';

const Terms = () => {
    const [language, setLanguage] = useState('es');

    const handleLanguageChange = (event, newLanguage) => {
        if (newLanguage !== null) {
            setLanguage(newLanguage);
        }
    };

    const content = {
        es: {
            title: 'Términos y Condiciones de VideoCallShop',
            lastUpdated: 'Última actualización: 22 de abril de 2026',

            s1Title: '1. Partes',
            s1Body: [
                'Estos términos rigen la relación entre VIDEO CALL SHOP S.A.S., CUIT 30-71592719-1, con domicilio legal en 9 de Julio 555, 9° "A", Rosario, Provincia de Santa Fe, Argentina (CP 2000) — en adelante, "VideoCallShop" — y el Usuario que accede o utiliza la plataforma.',
            ],

            s2Title: '2. Descripción del servicio',
            s2Body:
                'VideoCallShop es una plataforma B2B que permite a comerciantes atender clientes por video y cerrar ventas en vivo.',

            s3Title: '3. Elegibilidad',
            s3Body:
                'Para utilizar el servicio debés ser mayor de 18 años, tener capacidad legal para contratar y representar a un comercio real y lícito.',

            s4Title: '4. Cuenta y seguridad',
            s4Body:
                'Sos responsable de las credenciales de tu cuenta. Está prohibido compartirlas con terceros. Si detectás un acceso no autorizado, debés notificarnos de inmediato.',

            s5Title: '5. Uso aceptable',
            s5Intro: 'Queda prohibido usar el servicio para:',
            s5Items: [
                'Actividades ilegales, fraude o lavado de activos.',
                'Publicar o transmitir contenido sexual, violento, discriminatorio u ofensivo.',
                'Enviar spam o hacer publicidad engañosa.',
                'Suplantar la identidad de personas o marcas.',
                'Infringir derechos de propiedad intelectual u otros derechos de terceros.',
                'Vender productos prohibidos por ley (armas, drogas ilegales, productos falsificados, entre otros).',
            ],

            s6Title: '6. Contenido generado por usuarios',
            s6Body:
                'El Usuario es el único responsable del contenido que publica. Al publicarlo, nos otorga una licencia no exclusiva, mundial y gratuita para alojarlo, mostrarlo y transmitirlo dentro del contexto del servicio. Nos reservamos el derecho de eliminar cualquier contenido, suspender la cuenta y reportar a las autoridades si corresponde.',

            s7Title: '7. Moderación y reportes',
            s7Body:
                'La app permite reportar contenido inapropiado. Revisamos los reportes dentro de las 24 horas hábiles siguientes. Según la gravedad, podemos ocultar el contenido, bloquear al usuario involucrado o suspender la cuenta.',

            s8Title: '8. Pagos',
            s8Items: [
                'Los pagos entre comprador y vendedor son procesados por Mercado Pago o Payway, con la cuenta de cada comercio.',
                'VideoCallShop no interviene en la transacción financiera.',
                'El vendedor es el único responsable del producto o servicio vendido, sus garantías, los impuestos aplicables, la facturación y la post-venta.',
                'Comisiones de la plataforma: sin comisiones durante el período de lanzamiento.',
            ],

            s9Title: '9. Propiedad intelectual',
            s9Body:
                'VideoCallShop, su logo, código y diseño son propiedad de VIDEO CALL SHOP S.A.S. Ningún término de este acuerdo transfiere esos derechos al Usuario.',

            s10Title: '10. Terminación',
            s10Items: [
                'Por el Usuario: podés cerrar tu cuenta en cualquier momento desde Configuración → Eliminar cuenta.',
                'Por nosotros: podemos suspender o terminar la cuenta por incumplimiento de estos términos, con o sin preaviso según la gravedad de la infracción.',
            ],

            s11Title: '11. Descargo de garantías',
            s11Body:
                'El servicio se presta "tal cual" y "según disponibilidad". No garantizamos una disponibilidad ininterrumpida ni la ausencia de errores.',

            s12Title: '12. Limitación de responsabilidad',
            s12Body:
                'En la máxima medida permitida por la ley argentina, nuestra responsabilidad total frente al Usuario queda limitada al monto efectivamente pagado por el Usuario en los últimos 12 meses y, en su defecto, a la suma de AR$ 100.000.',

            s13Title: '13. Indemnidad',
            s13Body:
                'El Usuario mantendrá indemne a VIDEO CALL SHOP S.A.S. frente a reclamos de terceros derivados del uso del servicio por parte del Usuario o del incumplimiento de estos términos.',

            s14Title: '14. Modificaciones',
            s14Body:
                'Podremos modificar estos términos avisando con al menos 15 días de antelación. El uso continuado del servicio luego de la fecha de vigencia implica la aceptación de los nuevos términos.',

            s15Title: '15. Ley aplicable y jurisdicción',
            s15Body:
                'Estos términos se rigen por las leyes de la República Argentina. Para toda controversia, las partes se someten a la jurisdicción de los Tribunales Ordinarios de la ciudad de Rosario, Provincia de Santa Fe, con renuncia expresa a cualquier otro fuero.',

            s16Title: '16. Contacto',
            s16Body: 'Para consultas legales: legal@videocallshop.com.',
        },
        en: {
            title: 'VideoCallShop Terms of Service',
            lastUpdated: 'Last updated: April 22, 2026',

            s1Title: '1. Parties',
            s1Body: [
                'These terms govern the relationship between VIDEO CALL SHOP S.A.S., CUIT 30-71592719-1, with registered address at 9 de Julio 555, 9° "A", Rosario, Province of Santa Fe, Argentina (ZIP 2000) — hereinafter, "VideoCallShop" — and the User who accesses or uses the platform.',
            ],

            s2Title: '2. Service description',
            s2Body:
                'VideoCallShop is a B2B platform that lets merchants serve customers by video and close sales live.',

            s3Title: '3. Eligibility',
            s3Body:
                'To use the service you must be at least 18 years old, have legal capacity to contract, and represent a real and lawful business.',

            s4Title: '4. Account and security',
            s4Body:
                'You are responsible for your account credentials. Sharing them with third parties is prohibited. If you detect unauthorized access, you must notify us immediately.',

            s5Title: '5. Acceptable use',
            s5Intro: 'You may not use the service to:',
            s5Items: [
                'Carry out illegal activities, fraud, or money laundering.',
                'Publish or transmit sexual, violent, discriminatory, or offensive content.',
                'Send spam or run misleading advertising.',
                'Impersonate people or brands.',
                "Infringe intellectual property rights or any other third-party rights.",
                'Sell products prohibited by law (weapons, illegal drugs, counterfeit goods, among others).',
            ],

            s6Title: '6. User-generated content',
            s6Body:
                'You are solely responsible for the content you post. By posting it, you grant us a non-exclusive, worldwide, royalty-free license to host, display, and transmit it within the context of the service. We reserve the right to remove any content, suspend the account, and report to authorities where appropriate.',

            s7Title: '7. Moderation and reports',
            s7Body:
                'The app allows reporting of inappropriate content. We review reports within 24 business hours. Depending on severity, we may hide the content, block the user involved, or suspend the account.',

            s8Title: '8. Payments',
            s8Items: [
                'Payments between buyer and seller are processed by Mercado Pago or Payway, using each merchant\'s own account.',
                'VideoCallShop does not intervene in the financial transaction.',
                'The seller is solely responsible for the product or service sold, its warranties, applicable taxes, invoicing, and after-sales support.',
                'Platform fees: no fees during the launch period.',
            ],

            s9Title: '9. Intellectual property',
            s9Body:
                'VideoCallShop, its logo, code, and design are the property of VIDEO CALL SHOP S.A.S. No provision of this agreement transfers those rights to the User.',

            s10Title: '10. Termination',
            s10Items: [
                'By the User: you can close your account at any time from Settings → Delete account.',
                'By us: we may suspend or terminate the account for breach of these terms, with or without prior notice depending on the severity of the breach.',
            ],

            s11Title: '11. Disclaimer of warranties',
            s11Body:
                'The service is provided "as is" and "as available". We do not warrant uninterrupted availability or the absence of errors.',

            s12Title: '12. Limitation of liability',
            s12Body:
                'To the maximum extent permitted by Argentine law, our total liability to the User is limited to the amount actually paid by the User in the previous 12 months or, in its absence, to the sum of ARS 100,000.',

            s13Title: '13. Indemnity',
            s13Body:
                'The User shall hold VIDEO CALL SHOP S.A.S. harmless against third-party claims arising from the User\'s use of the service or from the breach of these terms.',

            s14Title: '14. Modifications',
            s14Body:
                'We may modify these terms with at least 15 days\' prior notice. Continued use of the service after the effective date constitutes acceptance of the new terms.',

            s15Title: '15. Governing law and jurisdiction',
            s15Body:
                'These terms are governed by the laws of the Argentine Republic. Any dispute shall be submitted to the Ordinary Courts of the city of Rosario, Province of Santa Fe, with express waiver of any other jurisdiction.',

            s16Title: '16. Contact',
            s16Body: 'For legal inquiries: legal@videocallshop.com.',
        },
    };

    const t = content[language];

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 3,
                        flexWrap: 'wrap',
                        gap: 2,
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{ fontWeight: 'bold', flex: 1, minWidth: '200px' }}
                    >
                        {t.title}
                    </Typography>
                    <ToggleButtonGroup
                        value={language}
                        exclusive
                        onChange={handleLanguageChange}
                        aria-label="language selection"
                        size="small"
                    >
                        <ToggleButton value="es" aria-label="español">
                            ES
                        </ToggleButton>
                        <ToggleButton value="en" aria-label="english">
                            EN
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                    {t.lastUpdated}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s1Title}
                </Typography>
                {t.s1Body.map((line, index) => (
                    <Typography key={index} variant="body1" paragraph>
                        {line}
                    </Typography>
                ))}

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s2Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s2Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s3Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s3Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s4Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s4Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s5Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s5Intro}
                </Typography>
                <Typography variant="body1" component="ul" sx={{ ml: 2, mb: 2 }}>
                    {t.s5Items.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s6Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s6Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s7Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s7Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s8Title}
                </Typography>
                <Typography variant="body1" component="ul" sx={{ ml: 2, mb: 2 }}>
                    {t.s8Items.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s9Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s9Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s10Title}
                </Typography>
                <Typography variant="body1" component="ul" sx={{ ml: 2, mb: 2 }}>
                    {t.s10Items.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s11Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s11Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s12Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s12Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s13Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s13Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s14Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s14Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s15Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s15Body}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
                    {t.s16Title}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t.s16Body}
                </Typography>

                <Box sx={{ mt: 4, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <Link href="/privacy-policy">
                        {language === 'es' ? 'Política de Privacidad' : 'Privacy Policy'}
                    </Link>
                    <Link href="/community-guidelines">
                        {language === 'es' ? 'Normas de la Comunidad' : 'Community Guidelines'}
                    </Link>
                    <Link href="/support">
                        {language === 'es' ? 'Soporte' : 'Support'}
                    </Link>
                </Box>
            </Paper>
        </Container>
    );
};

export default Terms;
